import React from 'react';
import { Row, Col, CardBody, CardTitle, CardText, Card, Badge } from 'reactstrap';
import './rastreabilidade.styles.css';
import IntlMessage from '../../../helpers/intlMessage';

const RastreabilidadePage = (props) => {
    return (
        <div className="mv-rastreabilidade">
            <div style={{ height: `${props.altura - 38}px`, width: '100%', overflowY: 'scroll', overflowX: 'hidden', maxHeight: '470px' }}>
                {
                    props.listagemRastreabilidade.map((item, i) => {
                        return (
                            <Row key={(item.dataHora.replace(/\//g, '').replace(/:/g, '').replace(' ', '')) + item.tipoOperacao.slice(0, 1) + i}>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>
                                                <strong><IntlMessage id = "dashboards.examDetail.date"/> </strong>{item.dataHora}
                                            </CardTitle>
                                            <CardText>
                                                <strong><IntlMessage id = "dashboards.examDetail.operation"/> </strong>{item.origem === 'rastreabilidade' ? 'RECOLHIMENTO' : item.tipoOperacao}
                                                {
                                                    item.origem === 'RASTREABILIDADE' && <Badge className="bagde">
                                                        <IntlMessage id = "dashboards.examDetail.sectorChange"/>
                                                    </Badge>
                                                }
                                            </CardText>
                                            <CardText><strong><IntlMessage id = "dashboards.examDetail.user"/> </strong>{item.usuario}</CardText>
                                            <CardText><strong><IntlMessage id = "dashboards.examDetail.action"/> </strong>{item.descricao}</CardText>
                                            {
                                                !!item.justificativaDoUsuario && <CardText>
                                                    <strong><IntlMessage id = "dashboards.examDetail.userJustification"/> </strong>{item.justificativaDoUsuario}
                                                </CardText>
                                            }
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default RastreabilidadePage;


// WEBPACK FOOTER //
// ./src/app/common/rastreabilidade/rastreabilidade.page.js